import { render, staticRenderFns } from "./AsMainWorkorderSubList.vue?vue&type=template&id=2b6f373c"
import script from "./AsMainWorkorderSubList.vue?vue&type=script&lang=js"
export * from "./AsMainWorkorderSubList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports